/**
 * @author Maxime Mustarda <maxime@inarix.com>
 * @file parseLicenceCredits.tsx
 * @desc Created on Wed Apr 30 2025 17:12:53
 * @copyright All rights reserved @ Inarix
 */

import { Chip } from "@mui/material";
import { Link } from "react-router-dom";
import {
  ExtendedLicense,
  LicenseStatus,
  PackStatus,
} from "../../redux/actions/licenses/licenceTypes";

export function remainingCredsPct(li: ExtendedLicense) {
  const currPackCreds =
    (
      li.packs?.find((p) => p.statusConstantId === PackStatus.active) ||
      li.packs?.findLast((p) => p.statusConstantId === PackStatus.emptied)
    )?.initialCredits || 0;
  const nextCredits = li.packs?.reduce(
    (total, p) =>
      (total += p.statusConstantId === PackStatus.bound ? p.initialCredits : 0),
    0,
  );
  const availableCreds = li.availableCredits + nextCredits;
  const totalCreds = currPackCreds + nextCredits;

  return {
    pct: availableCreds / (totalCreds || 1),
    // totalCreds,
    // availableCreds,
    currPackCreds,
    nextCredits,
  };
}

export function licenseIsInfinite(li: ExtendedLicense) {
  return (
    li.statusConstantId === LicenseStatus.ongoing &&
    li.licenseTemplate.parameters?.defaultScenarioCost === 0 &&
    !li.licenseTemplate.parameters?.specificScenarioCosts
  );
}

export function renderLicenseCredits(
  licenses: ExtendedLicense[],
  addTxt?: string,
  expireTxt?: string,
) {
  if (!licenses?.length && addTxt) {
    return <Link to="#">{addTxt}</Link>;
  }

  for (const license of licenses) {
    if (license.statusConstantId === LicenseStatus.expired) {
      continue;
    }

    if (licenseIsInfinite(license)) {
      // unlimited license
      return <span>∞</span>;
    }

    if (license.statusConstantId <= LicenseStatus.emptied) {
      const { pct, currPackCreds } = remainingCredsPct(license);
      const color = pct >= 0.2 ? "success" : pct >= 0.1 ? "warning" : "error";

      return (
        <>
          <Chip
            style={{ height: 10, width: 10, marginRight: 5 }}
            color={color}
            variant="filled"
          />
          &nbsp;&nbsp;
          <span>{`${license.availableCredits} / ${currPackCreds}`}</span>
        </>
      );
    }
  }

  return <Chip label={expireTxt} variant="outlined" />;
}

export function renderLicenseExtrapack(
  licenses: ExtendedLicense[],
  addTxt?: string,
  expireTxt?: string,
) {
  if (!licenses?.length && addTxt) {
    return <Link to="#">{addTxt}</Link>;
  }

  for (const license of licenses) {
    if (license.statusConstantId === LicenseStatus.expired) {
      continue;
    }

    if (licenseIsInfinite(license)) {
      // unlimited license
      return <span>∞</span>;
    }

    if (license.statusConstantId <= LicenseStatus.emptied) {
      const { nextCredits } = remainingCredsPct(license);

      return (
        <>
          &nbsp;&nbsp;
          <span>{`${nextCredits ? ` (+${nextCredits})` : "-"}`}</span>
        </>
      );
    }
  }

  return <Chip label={expireTxt} variant="outlined" />;
}
